/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { InviteUserPage } from '@/pages/InviteUser/InviteUserPage';

export function InviteUserRoute() {
  return <InviteUserPage />;
}
